import React from 'react';
import { Box, Flex, Icon, Text, useColorMode } from '@chakra-ui/react';
import CheckoutForm from './CheckoutForm';
import PowerBy from './powerby';
import { MdArrowBack } from 'react-icons/md';
import Link from 'next/link';
import { bgColor, borderColor, colorText } from 'config/data';
// import { API } from 'config/api';

const Step2 = ({ setStep, data, access_token, setNft, quantity, updated, intentUsd }) => {
  // const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //   setLoading(true);
  //   let isSubscribed = true;
  //   let config = { headers: { Authorization: `Bearer ${access_token}` } };
  //   API.post(`nft/mintPool/${data.id}/intent`, { method: 'usd' }, config)
  //     .then((res) => {
  //       if (isSubscribed) {
  //         console.log(res);
  //         setLoading(false);
  //       }
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  //   return () => (isSubscribed = false);
  // }, [access_token, data.id]);

  const { colorMode } = useColorMode();

  return (
    <Flex id="content" alignItems="center" flexDirection={{ base: 'column', md: 'row' }}>
      <Flex flexDirection="column" m="0 auto" alignItems="center" justifyContent="center" minH="100vh" id="form">
        <Box
          w={{ base: '100%', md: '520px' }}
          p={{ base: '10px', md: '20px' }}
          borderWidth={1}
          borderColor={borderColor[colorMode]}
          borderRadius={8}
          mt="30px"
          bg={bgColor[colorMode]}
          color={colorText[colorMode]}
        >
          <Flex onClick={() => setStep(1)} mb="20px">
            <Icon as={MdArrowBack} cursor="pointer" fontSize="22px" mr="10px" />
            <Text fontSize="14px" fontWeight="600" cursor="pointer">
              Back
            </Text>
          </Flex>
          <CheckoutForm
            nftData={data}
            access_token={access_token}
            setStep={setStep}
            setNft={setNft}
            quantity={quantity}
            updated={updated}
            intentUsd={intentUsd}
          />
        </Box>
        <Flex id="links" mt="14px" fontSize="13px" justifyContent="center">
          <Link href="/terms-of-service">
            <a style={{ color: '#2f80ed' }} target="_blank">
              Terms of Service
            </a>
          </Link>
          <Text mx="8px">and</Text>
          <Link href="/privacy-policy">
            <a style={{ color: '#2f80ed' }} target="_blank">
              Privacy Policy
            </a>
          </Link>
        </Flex>
        <Box mt={{ base: '14px', md: 0 }}>
          <PowerBy />
        </Box>
      </Flex>
    </Flex>
  );
};

export default Step2;
